import { InjectionToken } from '@angular/core';

export type ErrorSelectorFunc = (err: unknown) => unknown;
export const ERROR_SELECTOR_FUNC = new InjectionToken<ErrorSelectorFunc>('ErrorSelectorFunc Injection Token');
export const ERROR_SELECTOR_FUNC_ARRAY = new InjectionToken<ErrorSelectorFunc>('ErrorSelectorFunc[] Injection Token');
